import { FC, useMemo } from "react";
import { useGetIntentBuyersJourneyQuery } from "@/generated/taxonomy";
import { TAXONOMY_CLIENT } from "@/utils/consts";
import { CheckboxListFilter } from "./CheckboxListFilter";

export interface BuyersJourneyCheckboxListProps {
  selectedIds: string[];
  onChange: (ids: string[]) => void;
}

export const BuyersJourneyCheckboxList: FC<BuyersJourneyCheckboxListProps> = ({
  selectedIds,
  onChange,
}) => {
  const { data, loading } = useGetIntentBuyersJourneyQuery({
    context: { clientName: TAXONOMY_CLIENT },
  });

  const options = useMemo(() => data?.intentBuyersJourney?.data ?? [], [data]);

  return (
    <CheckboxListFilter
      options={options}
      loading={loading}
      selectedIds={selectedIds}
      onChange={onChange}
      emptyMessage="No buyer's journey stages available"
      skeletonCount={2}
    />
  );
};
